define('app/filters/SegmentMenuView',['require','hbs!./SegmentMenuView.hbs','glu/itemView'],function(require) {
	'use strict';

	var tmpl = require('hbs!./SegmentMenuView.hbs'),
		ItemView = require('glu/itemView');

	return ItemView.extend({
		template: tmpl,

		events: {
			'click [data-qa="menu-set-as-column"]': 'setAsColumn'
		},

		serializeData: function() {
			return this;
		},

		setAsColumn: function() {
			this.options.report.addSegmentAsColumnById(this.model.get('id'));
			this.model.trigger('removeSegment');
		}
	});
});

